import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "new_client" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "info_box" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

import { AdapterApiService } from '../../_adapter';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeginningWork',
  emits: ["next"],
  setup(__props, { emit: __emit }) {

const adapter = AdapterApiService.getInstance();
const islegal = adapter.userInfo.value.IdentifiedStatus == 0;

const emits = __emit;


function GoNext() {
	emits("next");
}


return (_ctx: any,_cache: any) => {
  const _directive_localization = _resolveDirective("localization")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!islegal)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$localization.getTranslate("NewUser")), 1))
      : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
          _withDirectives(_createElementVNode("span", null, null, 512), [
            [_directive_localization, 'Identification.NewCompany.Header']
          ])
        ])),
    _createElementVNode("div", _hoisted_4, [
      (!islegal)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("ToStartWorkingWithOnlineBank")) + ", ", 1),
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate(
					"GoThroughIdentificationCardAndApecifyAddressCardDelivery"
				)) + "! ", 1)
          ]))
        : _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, null, 512)), [
            [_directive_localization, 'Identification.NewCompany.Message']
          ])
    ]),
    _createElementVNode("button", {
      class: "ui_continue_button",
      onClick: GoNext
    }, [
      _hoisted_8,
      _createTextVNode("  "),
      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Continue")), 1)
    ])
  ]))
}
}

})